import React, { useState, useEffect } from 'react'
import { TargetMarginsView } from './TargetMarginsView'

export const TargetMargins = (props) => {
    const [targetMargins, setTargetMargins] = useState({ gb: 30, eu: 30, us: 36, row: 36, ca: 35, au: 32 })

    useEffect(() => {
        props.callChildTargetMargin(targetMargins)
    }, [props, targetMargins])

    const onChangeTargetMargin = (e) => {
        setTargetMargins(prevState => ({
            ...prevState,
            [e.target.name]: e.target.value > 95 ? 95 : Number(e.target.value)
        }))
    }

    return <TargetMarginsView
        targetMargins={targetMargins}
        onChangeTargetMargin={onChangeTargetMargin}
    />
}